import axios from 'axios';
import { adminApiUrl } from '../config/api';
import { adminAuthService } from './adminAuth';

export interface Feedback {
  feedbackId: string;
  userId: string;
  rating: number;
  comment?: string;
  category: 'general' | 'bug_report' | 'feature_request' | 'ui_ux' | 'performance' | 'other';
  createdAt: string;
}

export interface FeedbackListResponse {
  feedback: Feedback[];
  count: number;
  lastEvaluatedKey?: string;
}

export interface ListFeedbackParams {
  limit?: number;
  lastEvaluatedKey?: string;
  search?: string;
  category?: string;
  rating?: number;
  userId?: string;
  startDate?: string;
  endDate?: string;
}

class FeedbackManagementService {
  private api = axios.create({
    baseURL: adminApiUrl,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  private async getAuthHeaders() {
    const token = adminAuthService.getToken();
    if (!token) {
      throw new Error('Not authenticated');
    }
    return {
      Authorization: `Bearer ${token}`,
    };
  }

  async listFeedback(params?: ListFeedbackParams): Promise<FeedbackListResponse> {
    const headers = await this.getAuthHeaders();
    const queryParams = new URLSearchParams();
    
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.lastEvaluatedKey) queryParams.append('lastEvaluatedKey', params.lastEvaluatedKey);
    if (params?.search) queryParams.append('search', params.search);
    if (params?.category) queryParams.append('category', params.category);
    if (params?.rating) queryParams.append('rating', params.rating.toString());
    if (params?.userId) queryParams.append('userId', params.userId);
    if (params?.startDate) queryParams.append('startDate', params.startDate);
    if (params?.endDate) queryParams.append('endDate', params.endDate);

    const response = await this.api.get<{data: FeedbackListResponse}>(
      `/admin/feedback?${queryParams.toString()}`,
      { headers }
    );
    return response.data.data;
  }

  async getFeedback(feedbackId: string): Promise<Feedback> {
    const headers = await this.getAuthHeaders();
    const response = await this.api.get<{data: {feedback: Feedback}}>(
      `/admin/feedback/${feedbackId}`,
      { headers }
    );
    return response.data.data.feedback;
  }
}

export const feedbackManagementService = new FeedbackManagementService();
